var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-items-center d-flex flex-column justify-content-center text-center"})
}
var staticRenderFns = []

export { render, staticRenderFns }